import {LogRespuestaOSE} from "../../../logEmisor/recursos/modelo/LogRespuestaOSE";

export class LogNoTransformados {
    public id: number;
    public requestDate: string;
    public requestType: string;
    public documentType: string;
    public document: string;
    public emisorRUC: string;
    public emisorNombre: string;
    public fileName: string;
    public fileContent: string;
    public seleccionado: boolean;
    public linkRequest: string;
    public linkResponse: string;

    public responseStatus: string;
    public responseMessage: string;
    public responseDate: string;
    public responseCode: string;

    public respuesta: LogRespuestaOSE[];


    constructor(id: number = null,
                requestDate: string = "",
                requestType: string = "",
                documentType: string = "",
                document: string = "",
                emisorRUC: string = "",
                emisorNombre: string = "",
                fileName: string = "",
                fileContent: string = "",
                seleccionado: boolean = false,
                linkRequest: string = "",
                linkResponse: string = "",
                responseStatus: string = "",
                responseMessage: string = "",
                responseDate: string = "",
                responseCode: string = "",
                respuesta: LogRespuestaOSE[] = []) {

        this.id = id;
        this.requestDate = requestDate;
        this.requestType = requestType;
        this.documentType = documentType;
        this.fileName = fileName;
        this.fileContent = fileContent;
        this.seleccionado = seleccionado;
        this.linkRequest = linkRequest;
        this.linkResponse = linkResponse;
        this.responseStatus = responseStatus;
        this.responseMessage = responseMessage;
        this.responseDate = responseDate;
        this.responseCode = responseCode;
        this.respuesta = respuesta;
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logNoTranformados/recursos/modelo/LogNoTransformados.ts